import { Badge, IconButton, makeStyles } from '@material-ui/core'
import { useContext, useRef, useState } from 'react'
import { MdMenu, MdNotifications } from 'react-icons/md'
import { GlobalContext } from '../App'
import { Avatar, AvatarImage } from '../components/ui/avatar'
import Notificacoes from './Notificacoes'
import OpcoesUsuario from './OpcoesUsuario'
import logo from '../css/logo.png'

// function ElevationScroll({ children }) {
//   const trigger = useScrollTrigger({
//     disableHysteresis: true,
//     threshold: 0,
//   })

//   return React.cloneElement(children, {
//     elevation: trigger ? 4 : 0,
//   })
// }

const BUTTON_SIZE = 35

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: (menuWidth) => menuWidth,
    width: (menuWidth) => `calc(100% - ${menuWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  avatar: {
    marginLeft: -10,
  },
  defaultIcon: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, .1)',
  },
  userButton: {
    borderRadius: '10rem',
    padding: '0 0px 0 0',
  },
  userAvatar: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    color: 'white',
  },
}))

const Header = () => {
  const { usuarioLogado, menuWidth, dispatch, menuOpen, notificacoes } =
    useContext(GlobalContext)
  const classes = useStyles(menuWidth)

  const user = {
    id: usuarioLogado.id,
    name: usuarioLogado.nome,
    mail: usuarioLogado.email,
    picture: usuarioLogado.foto,
  }

  const openMenu = () => dispatch({ field: 'menuOpen', value: !menuOpen })

  const refNotificacao = useRef()
  const refOpcoesUsuario = useRef()

  const [openNotificacao, setOpenNotificacao] = useState(false)
  const [openOpcoesUsuario, setOpenOpcoesUsuario] = useState(false)
  const toggleOpcoesUsuario = () => setOpenOpcoesUsuario((o) => !o)

  const toggleNotificacoes = () => setOpenNotificacao((o) => !o)

  return (
    <>
      <div
        color="primary"
        className="fixed bg-default w-full z-[100] p-2 items-center flex justify-between"
      >
        <div className="flex items-center ">
          <IconButton onClick={openMenu}>
            <MdMenu color="white" />
          </IconButton>
          <span className="tracking-tight text-md font-medium antialiased text-white">
            QikLook
          </span>
        </div>
        <div className="space-x-7">
          <IconButton
            title="Notificações"
            className={classes.userAvatar}
            onClick={toggleNotificacoes}
            ref={refNotificacao}
            zIndex={99}
          >
            <Badge
              badgeContent={
                notificacoes?.filter((not) => !not.dtLeitura).length
              }
              color="primary"
            >
              <MdNotifications />
            </Badge>
          </IconButton>
          <IconButton
            title="Opções"
            onClick={toggleOpcoesUsuario}
            ref={refOpcoesUsuario}
            className={classes.userButton}
          >
            <span className="mr-1 flex-initial text-white font-medium text-sm">
              {user.name}
            </span>
            <Avatar size="1">
              <AvatarImage src={logo} />
            </Avatar>
          </IconButton>
        </div>
      </div>
      <Notificacoes
        zIndex={99}
        {...{ openNotificacao, setOpenNotificacao }}
        ref={refNotificacao}
      />
      <OpcoesUsuario
        {...{ openOpcoesUsuario, setOpenOpcoesUsuario }}
        ref={refOpcoesUsuario}
      />
    </>
  )
}

export default Header
